import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'app-new-template',
  templateUrl: './new-template.component.html',
  styleUrls: ['./new-template.component.css']
})
export class NewTemplateComponent implements OnInit {

  templateForm!: UntypedFormGroup;
  isEditMode = false; 
  btnText = "Create template"
  id: any;
  account_validation_messages = {
    'template': [
      { type: 'required', message: 'Template Name is required' },
      { type: 'minlength', message: 'Template Name must be at least 5 characters long' },
      { type: 'maxlength', message: 'Template Name cannot be more than 25 characters long' },
    ],
  }
  constructor(private router: Router ,private formBuilder: UntypedFormBuilder, private route: ActivatedRoute,  private snackBar: MatSnackBar,) { 
    this.templateForm = this.formBuilder.group({
      template: [null, Validators.compose([
        Validators.maxLength(25),
        Validators.minLength(4),
        Validators.required
      ])],
      id: [null],
      company: [null],
      date: [null],
      pib: [null],
      more: [null],
    });
  }

  ngOnInit(): void {    
    let id = this.route.snapshot.paramMap.get('id')
    if(id)
     { 
       this.isEditMode = true;
       this.btnText = 'Save template';
    }
  }

  submit(){}

  close(){
    this.router.navigate(['/accounting'])
  }

  editTemplate(id:any){

  }

}
